import { render, staticRenderFns } from "./iconNotification.vue?vue&type=template&id=2f7f8d62"
import script from "./iconNotification.vue?vue&type=script&lang=js"
export * from "./iconNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports